import { Avatar } from '@pickleballinc/ui/components/ui/avatar';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { RankChange } from '@/modules/rankings/components/RankChange';
import { EventsBreakdown } from '@/modules/rankings/PlayerCard/EventsBreakdown';
import { HiddenAge } from '@/modules/rankings/PlayerCard/HiddenAge';
import { formatPoints } from '@/modules/rankings/rankingsUtils';

interface BigNonLiveProps {
  rank: string;
  age: string;
  fullName: string;
  country: string;
  avatarUrl: string;
  flagUrl: string;
  played: number;
  doublesPlayed: number;
  mixedPlayed: number;
  singlesPlayed: number;
  gender: string;
  isCurrentSeed: boolean;
  points: number;
  change: number;
  playerRedirectURL: string;
}

export const BigNonLive = ({
  rank,
  age,
  fullName,
  country,
  avatarUrl,
  flagUrl,
  played,
  doublesPlayed,
  mixedPlayed,
  singlesPlayed,
  gender,
  isCurrentSeed,
  points,
  change,
  playerRedirectURL,
}: BigNonLiveProps) => {
  return (
    <div className='container ml-0 flex w-full items-center justify-center border-b border-gray-200 p-0 py-3'>
      <div className='flex w-[6%] items-center justify-between pl-3 text-base font-semibold'>
        <span className='w-[55%]'>{rank}</span>
        <span className='w-[45%]'>
          <RankChange change={change} />
        </span>
      </div>
      <CustomLink
        href={playerRedirectURL}
        className='flex w-[44%] items-center justify-start space-x-3 overflow-hidden rounded-full'
      >
        <Avatar name={fullName} src={avatarUrl || undefined} size='xl' variant='gray' />
        <span className='flex flex-row gap-1'>
          <p className='text-base font-semibold text-gray-900'>{fullName}</p>
        </span>
      </CustomLink>
      <div className='flex w-[10%] items-center justify-start space-x-3'>
        <ImageWithFallback
          src={flagUrl ? flagUrl : undefined}
          className='fill size-6 rounded-full'
          alt={`${country} flag`}
          width={24}
          height={24}
        />
        <span className='text-md font-semibold text-gray-900'>{country}</span>
      </div>
      <div className='flex w-[10%] items-center justify-center text-base font-semibold text-gray-900'>
        {age === '-1' ? <HiddenAge /> : age}
      </div>
      <div className='relative flex w-[15%] items-center justify-center text-base font-semibold text-gray-900'>
        <span>{played}</span>
        {!isCurrentSeed ? (
          <EventsBreakdown
            doubles={doublesPlayed}
            mixed={mixedPlayed}
            singles={singlesPlayed}
            gender={gender}
            className='absolute left-1/2 top-1/2 mt-3 flex -translate-x-1/2 gap-x-2 whitespace-nowrap text-xs font-normal text-gray-500'
          />
        ) : null}
      </div>
      <div className='flex w-[15%] items-center justify-center text-lg font-semibold text-brand-700'>
        {formatPoints(points)}
      </div>
    </div>
  );
};
